/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Loading_Page_No_InternetInputs */



/**
* | output |
* | --- |
* | "Something went wrong while loading the page and it's probably because you do not have an internet connection. When the connection is back, you can click on \"..." |
*
* @param {Error_Loading_Page_No_InternetInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const error_loading_page_no_internet = /** @type {((inputs?: Error_Loading_Page_No_InternetInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Loading_Page_No_InternetInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Something went wrong while loading the page and it's probably because you do not have an internet connection. When the connection is back, you can click on \"Reload page\" below or reload directly in the browser.")
	return /** @type {LocalizedString} */ ("Någonting har gått fel när sidan skulle läsas in och det beror troligtvis på att du saknar internetanslutning. När anslutningen är tillbaka kan du klicka på \"Ladda om sidan\" nedan eller ladda om direkt i webbläsaren.")
});